<div class="metric-card" [class.metric-card--on-dark]="onDark" *ngIf="metric">
  <div class="metric-card__value">
    <span #valueEl class="metric-card__num">{{ rendered }}</span>
    <span class="metric-card__suffix" *ngIf="suffix">{{ suffix }}</span>
  </div>
  <div class="metric-card__label">{{ metric.label }}</div>
  <div class="metric-card__subtext">{{ metric.subtext }}</div>
</div>
